import { useRef, useCallback } from 'react';

export function usePostItHandlers({ postIts, setPostIts, scrollContainerRef, zoomRef }) {
  const dragPostItRef = useRef(null);   // { id, offsetX, offsetY }
  const resizePostItRef = useRef(null); // { id, startClientX, startClientY, startW, startH }

  const handleAddPostIt = useCallback((x, y) => {
    const newPostIt = {
      id: `postit-${Date.now()}`,
      x, y,
      text: '',
      color: 'yellow',
    };
    setPostIts(prev => [...prev, newPostIt]);
  }, [setPostIts]);

  const handleDeletePostIt = useCallback((id) => {
    setPostIts(prev => prev.filter(p => p.id !== id));
  }, [setPostIts]);

  const handlePostItTextChange = useCallback((id, text) => {
    setPostIts(prev => prev.map(p => p.id === id ? { ...p, text } : p));
  }, [setPostIts]);

  const handlePostItColorChange = useCallback((id, color) => {
    setPostIts(prev => prev.map(p => p.id === id ? { ...p, color } : p));
  }, [setPostIts]);

  const handlePostItDragStart = useCallback((id, e) => {
    const container = scrollContainerRef.current;
    if (!container) return;
    const rect = container.getBoundingClientRect();
    const canvasX = (e.clientX - rect.left + container.scrollLeft) / zoomRef.current;
    const canvasY = (e.clientY - rect.top + container.scrollTop) / zoomRef.current;
    const postIt = postIts.find(p => p.id === id);
    if (!postIt) return;
    dragPostItRef.current = {
      id,
      offsetX: canvasX - postIt.x,
      offsetY: canvasY - postIt.y,
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [postIts, scrollContainerRef]);

  const handlePostItResizeStart = useCallback((id, e) => {
    const postIt = postIts.find(p => p.id === id);
    if (!postIt) return;
    resizePostItRef.current = {
      id,
      startClientX: e.clientX,
      startClientY: e.clientY,
      startW: postIt.w || 200,
      startH: postIt.h || 140,
    };
  }, [postIts]);

  return {
    handleAddPostIt,
    handleDeletePostIt,
    handlePostItTextChange,
    handlePostItColorChange,
    handlePostItDragStart,
    handlePostItResizeStart,
    dragPostItRef,
    resizePostItRef,
  };
}
